// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * WE2 P4-03: OHLC header styles.
 */

.vnsc-ohlc-header {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 6px 12px;
	background: var(--vnsc-bg-secondary);
	border-bottom: 1px solid var(--vnsc-border);
	font-family: inherit;
	font-size: var(--vnsc-font-md, 12px);
	color: var(--vnsc-text-primary);
	z-index: 30;
}

.vnsc-ohlc-header__symbol {
	font-size: var(--vnsc-font-lg, 14px);
	font-weight: 700;
}

.vnsc-ohlc-header__timeframe {
	background: var(--vnsc-accent, #2962ff);
	color: #fff;
	padding: 2px 6px;
	border-radius: var(--vnsc-radius-sm, 3px);
	font-size: var(--vnsc-font-sm, 11px);
	font-weight: 600;
}

.vnsc-ohlc-header__values {
	color: var(--vnsc-text-secondary);
	white-space: nowrap;
}

.vnsc-ohlc-header__volume {
	color: var(--vnsc-text-secondary);
}

.vnsc-ohlc-header__change {
	font-weight: 600;
}

.vnsc-ohlc-header__menu {
	margin-left: auto;
	display: flex;
	align-items: center;
	gap: 8px;
}

.vnsc-ohlc-menu-btn {
	background: transparent;
	border: 1px solid transparent;
	border-radius: 4px;
	color: var(--vnsc-text-secondary, #a0a0a0);
	width: 28px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	transition: all 0.2s ease;
	padding: 0;
}

.vnsc-ohlc-menu-btn:hover {
	color: var(--vnsc-text-primary, #e0e0e0);
	background: var(--vnsc-bg-tertiary, #1c2430);
	border-color: var(--vnsc-border, #2a2a2a);
}

.vnsc-ohlc-menu-btn--active {
	color: var(--vnsc-accent, #2962ff);
	background: var(--vnsc-bg-tertiary, #1c2430);
	border-color: var(--vnsc-accent, #2962ff);
}

`, "",{"version":3,"sources":["webpack://./src/widget/styles/header.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,iBAAiB;CACjB,oCAAoC;CACpC,2CAA2C;CAC3C,oBAAoB;CACpB,oCAAoC;CACpC,+BAA+B;CAC/B,WAAW;AACZ;;AAEA;CACC,oCAAoC;CACpC,gBAAgB;AACjB;;AAEA;CACC,uCAAuC;CACvC,WAAW;CACX,gBAAgB;CAChB,yCAAyC;CACzC,oCAAoC;CACpC,gBAAgB;AACjB;;AAEA;CACC,iCAAiC;CACjC,mBAAmB;AACpB;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,QAAQ;AACT;;AAEA;CACC,uBAAuB;CACvB,6BAA6B;CAC7B,kBAAkB;CAClB,0CAA0C;CAC1C,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,yBAAyB;CACzB,UAAU;AACX;;AAEA;CACC,wCAAwC;CACxC,4CAA4C;CAC5C,yCAAyC;AAC1C;;AAEA;CACC,kCAAkC;CAClC,4CAA4C;CAC5C,yCAAyC;AAC1C","sourcesContent":["/**\r\n * WE2 P4-03: OHLC header styles.\r\n */\r\n\r\n.vnsc-ohlc-header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 12px;\r\n\tpadding: 6px 12px;\r\n\tbackground: var(--vnsc-bg-secondary);\r\n\tborder-bottom: 1px solid var(--vnsc-border);\r\n\tfont-family: inherit;\r\n\tfont-size: var(--vnsc-font-md, 12px);\r\n\tcolor: var(--vnsc-text-primary);\r\n\tz-index: 30;\r\n}\r\n\r\n.vnsc-ohlc-header__symbol {\r\n\tfont-size: var(--vnsc-font-lg, 14px);\r\n\tfont-weight: 700;\r\n}\r\n\r\n.vnsc-ohlc-header__timeframe {\r\n\tbackground: var(--vnsc-accent, #2962ff);\r\n\tcolor: #fff;\r\n\tpadding: 2px 6px;\r\n\tborder-radius: var(--vnsc-radius-sm, 3px);\r\n\tfont-size: var(--vnsc-font-sm, 11px);\r\n\tfont-weight: 600;\r\n}\r\n\r\n.vnsc-ohlc-header__values {\r\n\tcolor: var(--vnsc-text-secondary);\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.vnsc-ohlc-header__volume {\r\n\tcolor: var(--vnsc-text-secondary);\r\n}\r\n\r\n.vnsc-ohlc-header__change {\r\n\tfont-weight: 600;\r\n}\r\n\r\n.vnsc-ohlc-header__menu {\r\n\tmargin-left: auto;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n}\r\n\r\n.vnsc-ohlc-menu-btn {\r\n\tbackground: transparent;\r\n\tborder: 1px solid transparent;\r\n\tborder-radius: 4px;\r\n\tcolor: var(--vnsc-text-secondary, #a0a0a0);\r\n\twidth: 28px;\r\n\theight: 28px;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tcursor: pointer;\r\n\ttransition: all 0.2s ease;\r\n\tpadding: 0;\r\n}\r\n\r\n.vnsc-ohlc-menu-btn:hover {\r\n\tcolor: var(--vnsc-text-primary, #e0e0e0);\r\n\tbackground: var(--vnsc-bg-tertiary, #1c2430);\r\n\tborder-color: var(--vnsc-border, #2a2a2a);\r\n}\r\n\r\n.vnsc-ohlc-menu-btn--active {\r\n\tcolor: var(--vnsc-accent, #2962ff);\r\n\tbackground: var(--vnsc-bg-tertiary, #1c2430);\r\n\tborder-color: var(--vnsc-accent, #2962ff);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
